import { render, staticRenderFns } from "./PaginationFooterFront.vue?vue&type=template&id=312aa298"
import script from "./PaginationFooterFront.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginationFooterFront.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports